/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { h, FunctionalComponent } from '@stencil/core';
import { CRLReason } from '@peculiar/asn1-x509';
import { RowValue } from '../row';
import { Extension } from '../../../crypto/extension';
import { BasicExtension } from './basic_extension';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface ICRLReasonExtensionProps {
  extension: Extension<CRLReason>;
}

export const CRLReasonExtension: FunctionalComponent<ICRLReasonExtensionProps> = (props) => {
  const { extension } = props;

  return (
    <BasicExtension
      extension={extension}
    >
      <RowValue
        name="Reason"
        value={extension.value.toJSON()}
      />
    </BasicExtension>
  );
};
